var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{ref:"initialbox",attrs:{"options":_vm.initialList,"label":"Description","placeholder":"What would you like help with?"},on:{"search":_vm.onInitialInput},model:{value:(_vm.initial),callback:function ($$v) {_vm.initial=$$v},expression:"initial"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }